import PersonImage from '@/components/PersonImage';
import { Person } from '@/models/Person';
import { User } from '@/models/User';
import { ApplicationState } from '@/store';
import { changePasswordClear } from '@/store/identity/action';
import { activeUserRequest, firstAccessRequest, forgotPasswordRequest } from '@/store/person/action';
import { postFeedbackClear } from '@/store/user/action';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Switch from 'react-switch';
import Modal from '../Modal';
import '../style.scss';
import ChangePassword from './password';
import './style.scss';

interface PeopleCardProps {
    person: Person;
    user: User;
}

const PeopleCard = ({ person, user }: PeopleCardProps) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const { data: identity } = useSelector((state: ApplicationState) => state.identity);
    const {
        data: { colors },
    } = useSelector((state: ApplicationState) => state.appOrganization);

    const { totalActives, processingActivation } = useSelector((state: ApplicationState) => state.people);
    const { totalLicenses } = useSelector((state: ApplicationState) => state.appOrganization.data);

    const dispatch = useDispatch();

    const activeHandle = (prevState: boolean) => {
        const activate = prevState;
        user.activated = activate;
        const request = { activate, userId: user.id, applicationId: identity.user.applicationId, orgId: identity.orgId };
        dispatch(activeUserRequest(request));
    };

    const firstAccessHandle = () => {
        if (person.id) {
            dispatch(firstAccessRequest({ personId: person.id }));
        }
    };

    const forgotPasswordHandle = () => {
        dispatch(forgotPasswordRequest({ applicationId: identity.user.applicationId, orgId: identity.user.orgId, username: user.username }));
    };

    return (
        <>
            <Modal
                content={`${person.firstName} ${person.lastName}`}
                icon="email"
                rightButtonText="OK"
                target={`alert-modal-first-access-${person.id}`}
                title={strings.FIRST_ACCESS_EMAIL_SENT}
            />
            <div
                aria-hidden="true"
                aria-labelledby="modalLabel"
                className="modal fade person-card"
                id={`change-modal-${person.id}`}
                role="dialog"
                tabIndex={-1}
            >
                <div className="modal-dialog modal-dialog-centeresd modal-container" role="document">
                    <div className="change-modal-content modal-content">
                        <div className="modal-title">
                            <div className="inner-content">
                                <span className="text-title">{strings.CHANGE_PASSWORD}</span>
                            </div>
                            <i
                                className="material-icons-outlined align-middle"
                                data-dismiss="modal"
                                onClick={() => {
                                    postFeedbackClear();
                                    changePasswordClear();
                                }}
                                onKeyDown={() => {}}
                                role="button"
                                tabIndex={0}
                            >
                                close
                            </i>
                        </div>
                        <div className="modal-title">
                            <div className="inner-content">
                                <span className="text-title">{person.email}</span>
                            </div>
                        </div>
                        {user && user.id && <ChangePassword userId={user.id} />}
                    </div>
                </div>
            </div>
            <div className="d-flex people-card">
                <PersonImage size={44} src={person.thumbnail} />
                <div className="d-flex flex-column justify-content-center people-card-content pl-3">
                    <span className="people-title">{`${person.firstName} ${person.lastName}`}</span>
                    <div>
                        <span className="people-info-value">{person.email}</span>
                        <span className="people-info-key"> | </span>
                        <span className="people-info-value">{person.position || ''}</span>
                    </div>
                </div>
                <div className="people-actions">
                    <span>{user.activated ? strings.ACTIVE : strings.INACTIVE}</span>
                    <Switch
                        checked={user.activated}
                        checkedIcon={false}
                        disabled={processingActivation || (!user.activated && totalLicenses !== null && totalActives >= totalLicenses)}
                        handleDiameter={20}
                        height={14}
                        offColor="#d1d1d1"
                        offHandleColor="#b3b3b3"
                        onChange={activeHandle}
                        onColor={colors[0]}
                        onHandleColor={colors[0]}
                        uncheckedIcon={false}
                        width={30}
                    />
                    <div className="dropdown ml-4">
                        <i className="material-icons-outlined align-middle" data-toggle="dropdown" style={{ color: '#808080' }}>
                            more_horiz
                        </i>
                        <div className="dropdown-menu dropdown-menu-right mt-2">
                            <div className="triangle-container">
                                <div className="dropdown-triangle" />
                                <div className="dropdown-triangle-border" />
                            </div>
                            <Link className="dropdown-item pt-3 pb-3" to={`people/${person.id}/edit`}>
                                <i className="material-icons va-t m-right--xxs">edit</i>
                                {strings.EDIT}
                            </Link>
                            <div
                                className="dropdown-item pt-3 pb-3"
                                data-target={`#alert-modal-first-access-${person.id}`}
                                data-toggle="modal"
                                onClick={firstAccessHandle}
                                onKeyDown={() => {}}
                                role="button"
                                tabIndex={0}
                            >
                                <i className="material-icons-outlined va-t m-right--xxs">mail</i>
                                {strings.MAIL_FIRTS_ACCESS}
                            </div>
                            <div className="dropdown-item pt-3 pb-3" onClick={forgotPasswordHandle} onKeyDown={() => {}} role="button" tabIndex={0}>
                                <i className="material-icons-outlined va-t m-right--xxs">mail</i>
                                {strings.MAIL_FORGOT_PASSWORD}
                            </div>
                            <div
                                className="dropdown-item pt-3 pb-3"
                                data-target={`#change-modal-${person.id}`}
                                data-toggle="modal"
                                onClick={() => {}}
                                onKeyDown={() => {}}
                                role="button"
                                tabIndex={0}
                            >
                                <i className="material-icons-outlined va-t m-right--xxs">vpn_key</i>
                                {strings.PASSWORD_REDEFINE}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PeopleCard;
